import { useState, type ReactNode } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { createTRPCContext } from "@trpc/tanstack-react-query";
import type { BackendRouter } from "@puzzleini/backend/router";
import { useAuth } from "../auth";
import { credentialedWebsiteApiFetch } from "../auth/authentication-request-transport";
import { env } from "../config/env";
import { createBackendClient } from "./client";

const { TRPCProvider, useTRPC, useTRPCClient } =
  createTRPCContext<BackendRouter, { keyPrefix: true }>();

export const useApi = useTRPC;
export const useApiClient = useTRPCClient;

export function ApiProvider({
  children,
  client,
}: {
  children: ReactNode;
  client?: ReturnType<typeof createBackendClient>;
}) {
  const queryClient = useQueryClient();
  const { user } = useAuth();
  const [defaultClient] = useState(() =>
    client ?? createBackendClient(env.VITE_API_URL, credentialedWebsiteApiFetch),
  );
  return (
    <TRPCProvider
      trpcClient={client ?? defaultClient}
      queryClient={queryClient}
      keyPrefix={user?.id ?? "anonymous"}
    >
      {children}
    </TRPCProvider>
  );
}
